import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPen} from '@fortawesome/free-solid-svg-icons';
import Avatar from 'react-avatar';

import {AppState} from '../Store';
import {Author} from '../Services/AuthorService';
import AuthorLink from './AuthorLink';

interface AuthorProfileProps {
  author?: Author;
  admin: boolean;

  getLink: (id: number) => string;
}

function AuthorProfile({author, getLink, admin}: AuthorProfileProps) {
  if (author === undefined) {
    return <div />;
  }

  return (
    <div className="profile text-center">
      <div className="profile-link">
        <AuthorLink id={author.id}>
          <div className="photo-container">
            <Avatar name={author.name} src={getLink(author.image)} size="123" />
          </div>
        </AuthorLink>
        <h3 className="title">
          <AuthorLink id={author.id}>{author.name}</AuthorLink>
          {admin ? <Link to={`/admin/authors/${author.id}`}> <FontAwesomeIcon icon={faPen} /></Link> : null}
        </h3>
      </div>
      <p className="category">{author.position}</p>
    </div>
  );
}

const mapStateToProps = (state: AppState) => ({
  getLink: state.auth.imageService.link,
  admin: state.auth.admin,
});

export default connect(mapStateToProps)(AuthorProfile);
